export default {
  // Sidebar Navigation
  sidebar: {
    dashboard: "Dashboard",
    recommendations: "Aanbevelingen",
    organizationDesign: "Organisatieontwerp",
    talentPool: "Talentenpool",
    reports: "Rapporten",
    notifications: "Meldingen",
    switchOrg: "Organisatie wisselen"
  },
  // Talent Pool / Users Page
  talentPool: {
    relationshipAddedSuccessfully: "Relatie succesvol toegevoegd",
    relationshipRemovedSuccessfully: "Relatie succesvol verwijderd",
    relationshipSavedSuccessfully: "Relatie succesvol opgeslagen",
    profileCard: "Profielkaart",
    viewOptions: {
      plan: "Plan",
      hierarchy: "Hiërarchie",
      network: "Netwerk"
    },
    searchPlaceholder: "Zoek gebruikers...",
    networkSearchPlaceholder: "Zoek netwerk...",
    hierarchySearchPlaceholder: "Zoek hiërarchie...",
    // KVDR Notifications
    kvdrNotifications: {
      create: "Aanmaken",
      roleCreatedSuccessfully: "Rol succesvol aangemaakt",
      delete: "Verwijderen",
      roleDeletedSuccessfully: "Rol succesvol verwijderd",
      addProfile: "Profiel toevoegen",
      profileAddedSuccessfully: "Profiel succesvol toegevoegd",
      removeProfile: "Profiel verwijderen",
      profileRemovedSuccessfully: "Profiel succesvol verwijderd",
      roleUpdate: "Rol-update",
      updatedSuccessfully: "Succesvol bijgewerkt",
      profileUpdate: "Profiel-update",
      profileUpdatedSuccessfully: "Profiel succesvol bijgewerkt"
    },
  },
  // Settings Help Page
  settingsHelp: {
    frequentlyAskedQuestions: "Veelgestelde Vragen",
    question1: "Hoe beheer ik de instellingen van mijn organisatie?",
    question2: "Hoe kan ik nieuwe leden uitnodigen voor mijn organisatie?",
    question3: "Wat zijn de verschillende gebruikersrollen en -machtigingen?",
    question4: "Hoe pas ik de branding van mijn organisatie aan?",
    helpText: "Dit is een voorbeeld hulptekst. Neem contact op met de ondersteuning voor specifieke hulp bij uw organisatie-instellingen en -configuratie."
  },
  // Create Organization
  createOrganization: {
    organizationName: "Organisatienaam",
    organizationUsername: "Organisatie gebruikersnaam",
    website: "Website",
    workEmail: "Werk e-mail",
    location: "Locatie",
    organizationType: "Organisatietype",
    primaryThemeColor: "Primaire themakleur",
    secondaryThemeColor: "Secundaire themakleur",
    about: "Over",
    saveChanges: "Wijzigingen opslaan",
    usernameExists: "Deze gebruikersnaam bestaat al",
    usernameAvailable: "Deze gebruikersnaam is beschikbaar",
    organizationTypeOptions: {
      business: "Zakelijk",
      academic: "Academisch",
      recruiter: "Recruiter"
    },
    logo: {
      adjustTitle: "Organisatielogo aanpassen",
      save: "Opslaan",
      uploadButton: "Logo uploaden",
      incorrectFileType: "Onjuist bestandstype",
      incorrectFileTypeText: "Upload een ondersteund afbeeldingsbestandstype, bijv. jpg, png, etc.",
      fileSizeExceeded: "Afbeeldingsbestandsgrootte overschreden",
      fileSizeExceededText: "De grootte van de profielfoto moet minder dan 1MB zijn."
    }
  },

  // Main Organizations List
  main: {
    select: "Selecteren",
    acceptInvitation: "Uitnodiging accepteren",
    noOrganizationFound: "Geen organisatie gevonden!",
    noOrganizationSubtext: "Maak eerst je eigen organisatie aan.",
    createOrganization: "Organisatie aanmaken"
  },

  // Organization Dashboard
  organization: {
    welcomeBack: "Welkom terug! 👋",
    setupComplete: "Setup voltooid!",
    setupProgress: "Setup: {step} van 4",
    copyLink: "Link kopiëren",
    linkCopied: "Link gekopieerd",
    criticalRoles: "Kritieke rollen",
    talentPool: "Talentpool",
    integrations: "Integraties",
    onboarding: "Onboarding",
    activeCandidates: "Actieve kandidaten",
    connectedApps: "Verbonden apps",
    pendingOnboards: "Wachtende onboards",
    kvdrReportsCenter: "KVDR Rapportagecentrum",
    kvdrReportsDescription: "Duik diep in je belangrijkste visuele datarapporten en krijg kritieke inzichten.",
    exploreReports: "Rapporten verkennen >",
    talentPoolExplorer: "Talentpool Verkenner",
    talentPoolDescription: "Ontdek, analyseer en beheer je beste talent met uitgebreide inzichten.",
    exploreTalentPool: "Talentpool verkennen >",
    thisMonth: "deze maand",
    goToOnboarding: "Ga naar onboarding"
  },

  // Reports
  reports: {
    title: "Rapporten",
    nineCellMatrix: "Negen-cel matrix",
    xyPlot: "XY-plot",
    talentScoreCard: "Talent scorekaart",
    emptyReports: "Lege rapporten",
    createKVDRFirst: "Maak eerst een KVDR aan en plan om rapporten te bekijken",
    // XY Plot specific
    xAxis: "X-as",
    yAxis: "Y-as",
    bubbleSize: "Bubbelgrootte",
    loadingChart: "Grafiek laden...",
    howToReadChart: "Hoe dit diagram te lezen",
    positioning: "Positionering",
    horizontalPosition: "Horizontale positie toont",
    verticalPosition: "Verticale positie toont",
    bubbleRepresentation: "Bubbelweergave",
    eachBubbleRepresents: "Elke bubbel vertegenwoordigt een werknemer",
    sizeIndicates: "Grootte geeft aan",
    quadrants: "Kvadranten",
    topLeft: "Boven-Links",
    topRight: "Boven-Rechts",
    bottomLeft: "Onder-Links",
    bottomRight: "Onder-Rechts",
    low: "Laag",
    high: "Hoog",
    interaction: "Interactie",
    hoverOverBubble: "Hover over een bubbel",
    revealsDetailedMetrics: "Toont gedetailleerde metingen voor die werknemer",
    colorCoding: "Kleurencodering",
    differentColorsHelp: "Verschillende kleuren helpen werknemers te onderscheiden",
    // Nine Cell Matrix specific
    nineCellMatrixTitle: "Werknemerscategorisering met negen-cel matrix",
    methodologyDescription: "Gestandaardiseerde methodologie gebaseerd op prestatiescore en opvolgingsbereidheid",
    loading: "Laden...",
    preparingMatrix: "Negen-cel matrix voorbereiden...",
    noDataAvailable: "Geen gegevens beschikbaar",
    employeeAssessmentRequired: "Werknemersevaluatiegegevens zijn vereist om de negen-cel matrix weer te geven.",
    successionReadiness: "Opvolgingsbereidheid",
    performanceScore: "Prestatiescore",
    bargain: "KOOPJES",
    bind: "BINDEN",
    backup: "BACKUP",
    onTrack: "OP KOERS",
    boost: "BOOST",
    build: "BOUWEN",
    bootBarter: "BOOT/RUIL",
    employees: "Werknemers",
    methodologyTitle: "Negen-cel matrix methodologie",
    methodologySubtitle: "Gestandaardiseerde werknemerscategorisering gebaseerd op prestatiescore en opvolgingsbereidheid berekeningen.",
    calculationMethod: "Berekeningsmethode",
    performanceScoreFormula: "Prestatiescore (P)",
    performanceScoreCalculation: "P = 0,6 × Prestatie + 0,4 × Beoordeling",
    performanceScoreNote: "Ruwe scores (-1 tot 1,5) worden genormaliseerd naar 0-100 schaal",
    successionReadinessFormula: "Opvolgingsbereidheid (R)",
    successionReadinessCalculation: "R = 0,5 × Opvolging + 0,3 × Passendheid + 0,2 × Jaren score",
    successionReadinessNote: "Ruwe scores (-1 tot 1,5) worden genormaliseerd naar 0-100 schaal",
    yearsScore: "Jaren score",
    yearsScoreCalculation: "Als Jaren ≥ 3: 100, anders: (Jaren / 3) × 100",
    yearsScoreNote: "Gebruikt momenteel standaard 2 jaar (configureerbaar)",
    cellCategories: "Celcategorieën",
    backupDescription: "Hoge prestatie, Hoge opvolging",
    boostDescription: "Gemiddelde prestatie, Hoge opvolging",
    bindDescription: "Hoge/Gemiddelde opvolging, Lage/Gemiddelde prestatie",
    onTrackDescription: "Gemiddelde/Lage prestatie, Gemiddelde/Lage opvolging",
    buildDescription: "Gemiddelde prestatie, Lage opvolging",
    bargainDescription: "Lage prestatie, Hoge opvolging",
    bootBarterDescription: "Hoge prestatie, Lage opvolging",
    // Talent Score Card specific
    criteria: "Criteria",
    talent: "TALENT",
    role: "ROL",
    remarks: "OPMERKINGEN",
    weightage: "Gewicht",
    good: "Goed (8-10)",
    average: "Gemiddeld (5-7)",
    poor: "Slecht (1-4)",
    notApplicable: "Niet van toepassing"
  },

  // Talent Pool
  talentPool: {
    title: "Talentpool",
    reviewRequest: "Beoordelingsverzoek",
    // Main talent pool
    noPendingRequest: "Geen openstaande verzoeken gevonden",
    importFrom: "Importeren van",
    uploadExcel: "excel uploaden",
    uploadResumes: "currícula uploaden",
    uploadResumesTooltip: "Importeren van currículums (PDF)",
    orHRIS: "of HRIS",
    pendingRequest: "Openstaand verzoek",
    allUsers: "Alle gebruikers",
    addNewEmployee: "Nieuwe werknemerskaart toevoegen",
    // Table headers
    name: "Naam",
    email: "E-mail",
    maxRole: "Max. rol",
    relationships: "Relaties",
    action: "Actie",
    // User search
    searchUser: "Gebruiker zoeken",
    userNotFound: "Gebruiker niet gevonden.",
    // Relationship management
    member: "Lid",
    relationship: "Relatie",
    addRelation: "Relatie toevoegen",
    removeRelationship: "Relatie verwijderen",
    // Add employee form
    firstName: "Voornaam",
    lastName: "Achternaam",
    roleTitle: "Roltitel",
    save: "Opslaan",
    // Profile card
    profileCard: "Profielkaart",
    // Import
    importFromExcel: "Importeren van Excel"
  },

  // Users
  users: {
    title: "Gebruikers",
    manageUsers: "Gebruikers beheren",
    // User Recommendations
    talentRecommendations: "Talentaanbevelingen",
    recommendationsDescription: "Gebaseerd op uw KVDR-beoordeling vindt u hier gepersonaliseerde aanbevelingen voor uw organisatie",
    viewActivePlans: "Actieve plannen bekijken",
    // Recommendation Cards
    fitmentPlan: "Passingsplan",
    fitmentPlanDescription: "Onboarding van mensen naar hun rollen.",
    fitmentPlanContent: "Onboarding van mensen naar hun rollen. Mapping van het juiste talent naar de juiste rollen met passingsindicatoren",
    developmentPlan: "Ontwikkelingsplan",
    developmentPlanDescription: "AI-aangedreven leren met ALEX",
    developmentPlanContent: "Het maken van leerplannen met ALEX Gepersonaliseerde leerpaden om de talentwaarde te verhogen met vaardigheden.",
    successionPlanning: "Opvolgingsplanning",
    successionPlanningDescription: "Bevorder en ondersteun loopbaangroei",
    successionPlanningContent: "Bevorder en ondersteun loopbaangroei Coaching-plannen voor vaardigheids- en tijdbereidheid voor de volgende rol.",
    // Benefits Lists
    roadToRole: "Weg naar je rol (Reis)",
    skillProfiling: "Vaardigheidsprofielering",
    learningCredits: "Leerkredieten",
    marketRewards: "Marktbeloningen",
    customLearningPaths: "Aangepaste leerpaden",
    aiAssistedValidation: "AI-ondersteunde validatie",
    progressTracking: "Voortgangsbewaking met ervaringspunten (XPs)",
    interactiveExercises: "Interactieve oefeningen",
    appraisalIndicators: "360° beoordelingsindicatoren",
    goalSettingMentorship: "Doelstelling en mentorschap",
    behaviouralCoaching: "Gedragscoaching en plannen",
    managedCareerGuidance: "Begeleide loopbaanbegeleiding",
    // Action Buttons
    onboard: "Onboarden",
    activate: "Activeren",
    promote: "Bevorderen",
    // Progress Section
    talentCapabilitySnapshot: "Talentvermogen momentopname",
    lastUpdated: "Laatst bijgewerkt: Vandaag",
    refresh: "Vernieuwen",
    // Score Labels
    industryLeader: "Industrieleider",
    highPerforming: "Hoog presterend",
    competitive: "Concurrerend",
    developing: "Ontwikkelend",
    foundationBuilding: "Fundament opbouwen",
    // Notifications
    alexActivated: "ALEX geactiveerd",
    alexActivatedText: "Uw AI-leerassistent staat klaar om te helpen!",
    coachingRequestSent: "Coachingverzoek verzonden",
    coachingRequestSentText: "Een coach neemt binnenkort contact met u op!",
    rewardsMarketplace: "Beloningsmarktplaats",
    rewardsMarketplaceText: "Beschikbare beloningen en voordelen verkennen!"
  },

  // Integrations
  integrations: {
    title: "Integraties",
    manageIntegrations: "Integraties beheren"
  },

  // Admins
  admins: {
    title: "Beheerders",
    manageAdmins: "Beheerders beheren"
  }
};
